import { render, staticRenderFns } from "./SwitchFilter.vue?vue&type=template&id=7350d816&"
import script from "./SwitchFilter.vue?vue&type=script&lang=js&"
export * from "./SwitchFilter.vue?vue&type=script&lang=js&"
import style0 from "./SwitchFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports